module.exports = __webpack_public_path__ + "static/media/Calendar_icon.391fa2c2.svg";